AuthService = ($rootScope, $location, $window, returnUrl,$cookies, SessionService, $q) ->
  afterSignedIn = ->
    $rootScope.$broadcast("signedIn.gnp.authService")
    localStorage.setItem "isSignedIn", true
    $cookies.remove('loginAttempt')

  signIn: (email, password) ->
    SessionService.create(email, password).then ->
      afterSignedIn()
      if returnUrl.external
        $window.location = returnUrl.url
      else
        $location.path returnUrl.url
        # next login time will go to dashboard
        returnUrl.url = '/'

  signInBypass: ->
    afterSignedIn()

  signOut: ->
    SessionService.destroy().then ->
      localStorage.clear()
      $rootScope.$broadcast("signedOut.gnp.authService")
      $location.path('/session/new')

  isSignedIn: ->
    localStorage.getItem("isSignedIn")

AuthService.$inject = [
  '$rootScope'
  '$location'
  '$window'
  'returnUrl'
  '$cookies'
  'SessionService'
  '$q'
]

module.exports = AuthService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/auth/auth-service.coffee